<template>
  <div class="w-full h-full">
    <!-- Banner：轻微缩放 + 标题自下而上淡入 -->
    <div class="relative w-full h-[250px] sm:h-[300px] md:h-[350px] lg:h-[400px] overflow-hidden">
      <img
        src="../../assets/img/fuwu_1.webp"
        alt="service-banner"
        class="w-full object-cover h-full transition-transform duration-[1200ms] ease-out"
      />
      <div class="absolute bottom-0 left-0 right-0 text-white text-[32px] sm:text-[48px] md:text-[60px] lg:text-[72px] font-bold container mx-auto flex flex-col items-start justify-center px-4 sm:px-6 scroll-fade-in">
        <div>服务案例</div>
        <div class="text-[20px] sm:text-[28px] md:text-[36px] lg:text-[48px] -mt-[8px] sm:-mt-[12px] md:-mt-[16px] lg:-mt-[20px] mb-4 sm:mb-6 md:mb-8 lg:mb-10">
          CASES
        </div>
      </div>
    </div>

    <!-- 地区选择：整体淡入 -->
    <div class="container mx-auto py-4 sm:py-6 md:py-6 px-4 sm:px-6 scroll-fade-in">
      <div class="flex flex-col gap-4 sm:gap-6">
        <div class="text-[20px] sm:text-[24px] md:text-[28px] lg:text-[32px] font-bold text-gray-800">地区选择</div>
        <div class="flex flex-col sm:flex-row gap-4 sm:gap-6 md:gap-8 w-full sm:w-[90%] md:w-[70%] lg:w-[50%]">
          <div class="flex flex-col gap-2 flex-1">
            <div class="text-[16px] sm:text-[20px] md:text-[22px] lg:text-[24px] font-bold text-gray-800">省份</div>
            <el-select
              v-model="selectedProvince"
              placeholder="请选择省份"
              class="w-full"
              @change="handleProvinceChange"
              :popper-class="'custom-select-dropdown'"
            >
              <el-option
                label="全部"
                value=""
              />
              <el-option
                v-for="province in provinces"
                :key="province.value"
                :label="province.label"
                :value="province.value"
              />
            </el-select>
          </div>
          <div class="flex flex-col gap-2 flex-1">
            <div class="text-[16px] sm:text-[20px] md:text-[22px] lg:text-[24px] font-bold text-gray-800">城市</div>
            <el-select
              v-model="selectedCity"
              placeholder="请选择城市"
              class="w-full "
              :disabled="!selectedProvince"
              @change="handleCityChange"
              :popper-class="'custom-select-dropdown'"
            >

              <el-option
                label="全部"
                value=""
              />
              <el-option
                v-for="city in cities"
                :key="city.value"
                :label="city.label"
                :value="city.value"
              />
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <!-- 案例区域：有数据展示网格，无数据展示占位 -->
    <div class="container mx-auto pb-4 sm:pb-4 px-4 sm:px-4 ">
      <!-- 有数据：案例卡片网格：左右交错飞入 + 科技感 hover -->
      <div
        v-if="caseList.length > 0"
        class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-5 md:gap-4"
      >
        <div
          v-for="(item, index) in caseList"
          :key="item.id"
          class="rounded-[8px] overflow-hidden relative w-full cursor-pointer transition-transform duration-500 ease-out hover:scale-[1.03] hover:shadow-[0_0_24px_rgba(41,255,248,0.25)]"
          :class="index % 2 === 0 ? 'scroll-fade-in-left' : 'scroll-fade-in-right'"
          :style="{ transitionDelay: (index * 40) + 'ms' }"
          @click="goToCaseDetail(item.id)"
        >
          <img
            :src="item.image"
            :alt="item.title"
            class="w-full h-[200px] sm:h-[250px] md:h-[300px] lg:h-[340px] object-cover transition-transform duration-700 ease-out hover:scale-105"
          />
          <div class="absolute bottom-0 left-0 right-0 p-3 sm:p-4 bg-gradient-to-t from-[#07409D] via-[#07409D]/80 to-[#FFFFFF]/40 min-h-[100px] sm:min-h-[110px] md:min-h-[120px] lg:min-h-[134px]">
            <div class="text-white text-[14px] sm:text-[15px] md:text-[16px] font-bold mb-1 sm:mb-2 truncate">
              {{ item.title }}
            </div>
            <div class="text-white text-[11px] sm:text-[12px] font-normal line-clamp-2 sm:line-clamp-3 mb-2">
              {{ item.description }}
            </div>
            <div class="flex flex-row items-center justify-between mt-1 sm:mt-2">
              <div class="text-[#29FFF8] text-[12px] sm:text-[13px] md:text-[14px] font-medium self-start hover:opacity-80 transition-opacity">
                查看详情&gt;&gt;&gt;
              </div>
              <div class="text-white text-[10px] sm:text-[11px] md:text-[12px] font-normal truncate max-w-[50%] text-right">
                {{ item.location || '' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="caseList.length === 0"
      class=" w-full h-auto bg-[#04193B]"
    >

      <div class="flex flex-col items-center justify-center container mx-auto pt-6 px-8 lg:px-0 sm:pt-6 md:pt-8 lg:pt-[64px] scroll-fade-in">
        <div class="text-white text-[16px] sm:text-[20px] md:text-[24px] lg:text-[24px] font-bold text-center">
          大空间门店开店 & 元宇宙大空间游戏拓展 合作招募中！<br class="hidden sm:block md:block lg:block" />
          您所在区域暂未布局合作案例，意味着专属的市场空白与先发优势。<br class="hidden sm:block md:block lg:block" />
          即刻填写表单，解锁定制化合作方案，抢占沉浸式赛道红利，我们期待与您携手共赢。
        </div>
        <div
          class="text-[#29FFF8] text-[16px] sm:text-[20px] md:text-[16px] lg:text-[16px]
           font-light border-2 border-white rounded-full px-4 py-2 bg-[#07409D] 
           mt-8
           cursor-pointer"
          @click="goToCaseList"
        >
          查看全部案例
        </div>

      </div>

      <div class=" w-full h-auto  bg-[#04193B] lg:pb-[77px] pb-6 lg:pt-[51px]  pt-6">
        <!-- 表单 -->
        <div class="w-full mx-auto px-4 sm:px-6 md:px-8">
          <div class="w-full max-w-[1400px] mx-auto">
            <CooperationForm />
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import api from "@/api";
import { RequestError } from "@/utils/request";
const router = useRouter();
import CooperationForm from "@/components/CooperationForm.vue";

// 跳转到案例详情页
const goToCaseDetail = (id: string) => {
  router.push(`/service/case/${id}.html`);
};

const goToCaseList = () => {
  selectedProvince.value = "";
  selectedCity.value = "";
  loadCaseList();
};

interface CaseItem {
  id: string;
  title: string;
  description: string;
  image: string;
  location?: string;
}

type CaseRaw = {
  id: string;
  title: string;
  image: string;
  content: string;
  address: string;
};

const caseList = ref<CaseItem[]>([]);

type SelectOption = { label: string; value: string };
type ProvinceRaw = { id: number; name: string };
type CityRaw = { id: number; name: string };

// 省份数据（对接接口 /api/news/getprovince）
const provinces = ref<SelectOption[]>([]);

// 城市数据（对接接口 /api/news/getcity）
const cities = ref<SelectOption[]>([]);

const selectedProvince = ref<string>("");
const selectedCity = ref<string>("");

// 省份改变时，重置城市选择
const handleProvinceChange = () => {
  selectedCity.value = "";
  cities.value = [];
  if (selectedProvince.value) {
    loadCities(selectedProvince.value);
    // 只选省份时：先按省份过滤拉取（若后端不支持，可再告诉我我帮你改成必须选城市）
    loadCaseList({ provinceId: selectedProvince.value });
  } else {
    // 未选省份/城市：拉取全部
    loadCaseList();
  }
};

const handleCityChange = () => {
  // 城市变化时刷新列表
  if (selectedProvince.value && selectedCity.value) {
    loadCaseList({
      provinceId: selectedProvince.value,
      cityId: selectedCity.value,
    });
  } else {
    // 没选城市：退回到“全部”或“仅省份”列表
    if (selectedProvince.value) {
      loadCaseList({ provinceId: selectedProvince.value });
    } else {
      loadCaseList();
    }
  }
};

const loadProvinces = async () => {
  try {
    const res = await api.region.getProvinces();
    const list = (res.data || []) as ProvinceRaw[];
    provinces.value = list.map((p) => ({ label: p.name, value: String(p.id) }));
  } catch (error) {
    console.error("加载省份失败:", error);
    if (error instanceof RequestError) {
      console.error("错误信息:", error.message);
    }
    provinces.value = [];
  }
};

const loadCities = async (provinceId: string) => {
  try {
    const res = await api.region.getCities(provinceId);
    const list = (res.data || []) as CityRaw[];
    cities.value = list.map((c) => ({ label: c.name, value: String(c.id) }));
  } catch (error) {
    console.error("加载城市失败:", error);
    if (error instanceof RequestError) {
      console.error("错误信息:", error.message);
    }
    cities.value = [];
  }
};

const loadCaseList = async (params?: {
  provinceId?: string;
  cityId?: string;
}) => {
  try {
    const res = await api.service.getCaseList(params);
    const list = (res.data || []) as CaseRaw[];
    caseList.value = list.map((item) => ({
      id: item.id,
      title: item.title,
      description: item.content,
      image: item.image,
      location: item.address,
    }));
  } catch (error) {
    console.error("加载服务案例失败:", error);
    if (error instanceof RequestError) {
      console.error("错误信息:", error.message);
    }
    caseList.value = [];
  }
};

onMounted(() => {
  loadProvinces();
  // 默认不选省份/城市时，也需要加载列表
  loadCaseList();
});
</script>

<style scoped>
:deep(.el-select) {
  width: 100%;
}

:deep(.el-select__suffix) {
  background-image: url("../../assets/img/arrow_down.svg") !important;
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
  width: 24px !important;
  height: 24px !important;
  transition: transform 0.3s ease !important;
}

:deep(.el-icon) {
  display: none !important;
}

:deep(.el-select__input) {
  height: 48px !important;
}

@media (min-width: 640px) {
  :deep(.el-select__input) {
    height: 56px !important;
  }
}

@media (min-width: 1024px) {
  :deep(.el-select__input) {
    height: 64px !important;
  }
}

:deep(.el-select__placeholder) {
  color: #333333 !important;
  font-size: 16px !important;
  font-weight: bold !important;
  line-height: normal !important;
}

@media (min-width: 640px) {
  :deep(.el-select__placeholder) {
    font-size: 20px !important;
    line-height: normal !important;
  }
}

@media (min-width: 1024px) {
  :deep(.el-select__placeholder) {
    font-size: 28px !important;
  }
}

:deep(.el-select__wrapper) {
  border: 1px solid #000000 !important;
  height: 48px !important;
  border-radius: 12px !important;
  background-color: #ebf1ff !important;
}

@media (min-width: 640px) {
  :deep(.el-select__wrapper) {
    height: 56px !important;
    border-radius: 14px !important;
  }
}

@media (min-width: 1024px) {
  :deep(.el-select__wrapper) {
    height: 64px !important;
    border-radius: 16px !important;
  }
}

:deep(.el-input__wrapper) {
  background-color: #e8f0f5;
  border-radius: 8px;
  box-shadow: none !important;
  padding: 12px 16px;
  border: none;
}

:deep(.el-input__inner) {
  color: #333;
  font-weight: 600;
  font-size: 14px !important;
}

@media (min-width: 640px) {
  :deep(.el-input__inner) {
    font-size: 15px !important;
  }
}

@media (min-width: 1024px) {
  :deep(.el-input__inner) {
    font-size: 16px !important;
  }
}

:deep(.el-input__wrapper:hover) {
  box-shadow: none !important;
}

:deep(.el-input.is-focus .el-input__wrapper) {
  box-shadow: 0 0 0 1px #409eff inset !important;
}

:deep(.el-select .el-input .el-select__caret) {
  color: #333;
  font-size: 14px;
}

:deep(.el-input.is-disabled .el-input__wrapper) {
  background-color: #f5f7fa;
  cursor: not-allowed;
}

:deep(.el-input.is-disabled .el-input__inner) {
  color: #c0c4cc;
}

.input-wrapper {
  position: relative;
}

.input-wrapper::before {
  content: "";
  position: absolute;
  top: 2px;
  /* 跳过 label 的高度（text-sm + mb-2 ≈ 2.5rem） */
  left: 0;
  width: 2px;
  bottom: 2px;
  /* 与底部边框对齐 */
  background: linear-gradient(180deg, #4a90e2, #4a90e2);
  pointer-events: none;
  border-radius: 2rem;
}

.input-wrapper::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, #4a90e2, #f161f9);
  opacity: 1;
  pointer-events: none;
  border-radius: 0 0 2rem 2rem;
}
</style>
